<template>
  <DialogTemplate style="--dialog-content-padding: 0">
    <div
      v-if="action === 'earlybird'"
      class="ma-12 f-column"
    >
      <div
        class="d-flex f-center clr-grey w-100"
        style="gap: 0.5rem"
      >
        <div class="uppercase text-medium clr-grey mr-auto">Elite Tier pre-order</div>
      </div>

      <div
        class="f-column text-centers text-normal-large weight_400 ml-auto mt-4"
        style="max-width: 25rem"
      >
        <div v-if="!canConfirm">
          I am ready to extend my <br />
          <span class="weight_600"> Elite tier subscription for</span>
          <span class="weight_600"> an additional year </span>
        </div>

        <div
          v-ripple="true"
          class="d-flex gw_btn gw_btn_text gw_btn_outline weight_500 text-normal-large mt-4"
          :class="{ gw_btn_primary: isSelected }"
          :style="isSelected ? '--clr-active-white: var(--clr-primary);' : ''"
          style="
            --height: auto;
            --border: solid 1px var(--clr-active-white);

            justify-content: flex-start;
            align-items: flex-start;
            padding: 1rem;
          "
          @click="isSelected = !isSelected"
        >
          <Checkbox
            class="mr-2"
            style="--icon-size: 1.15rem"
            :value="isSelected"
          >
            <template #content> </template>
          </Checkbox>
          <div
            class="f-column weight_600"
            style="gap: 0.75rem"
          >
            <div class="weight_600">Elite Tier 1-Year Extension</div>

            <div class="d-flex">Total: $1,308</div>
          </div>
        </div>
      </div>
      <div class="d-flex ml-autos mt-4">
        <div class="f-column w-100">
          <div
            class="gw_btn w-100 weight_600 text-normal-large pa-5"
            :class="!isSelected ? 'clr-grey no-events' : 'gw_btn_primary'"
            style="--clr-disabled: var(--clr-grey-2)"
            @click="apply()"
          >
            <LoaderSpinner
              v-show="loading"
              style="--size: 1.5rem; position: absolute"
            />
            <div v-show="!loading">Confirm</div>
          </div>
          <div
            class="text-small clr-grey mt-1"
            style="max-width: 23rem; text-align: justify"
          >
            By selecting “Confirm Extension”, your saved payment method will be charged. Please note
            that it may take up to 24 hours for your subscription extension to be processed. Once
            complete, an extra 12 months will be added to your existing subscription period
            seamlessly.
          </div>
        </div>
      </div>
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import tier_mix from '@/mixins/tier_mix'

export default {
  name: 'PromptDialog',
  components: {
    DialogTemplate,
    Checkbox,
    LoaderSpinner,
  },
  mixins: [tier_mix],
  props: {
    dialog: Object,
  },
  data() {
    return {
      canConfirm: false,
      isSelected: false,
      loading: false,
      // loading: true,
    }
  },
  methods: {
    apply() {
      if (!this.isSelected) return

      this.$store.dispatch('account_settings_patch', {
        data: { early_bird_application_status: 'APPLIED' },
      })
      this.loading = true
      setTimeout(() => {
        this.close()
      }, 666)
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'prompt-dialog')
    },
  },
  computed: {
    action() {
      return this.dialog.action
    },
  },
}
</script>

<style lang="scss" scoped>
.mmbtn {
  // min-width: 9rem;
}
.rb-dialog_action {
  border-radius: 4px;
  text-shadow: var(--text-shadow_drop);
  min-width: 6rem;
}
</style>
